export const OPTIONS_CONST = {
  allowDuplicateParticipant: '참여 횟수 제한 없음',
  notAllowDuplicateParticipant: '참여 횟수 1회 제한',
  exposed: '노출',
  notExposed: '미노출',
  onlyApp: '에코야 얼스 앱',
  onlyWeb: '제휴사 웹',
  displayed: '노출',
  notDisplayed: '미노출',
  showed: '노출',
  notShowed: '미노출',
  viewable: '노출',
  notViewable: '미노출',
  applied: '적용',
  notApplied: '미적용',
  activated: '사용',
  notActivated: '미사용',
  enabled: '사용',
  disabled: '미사용',
  advertisement: '광고',
  notAdvertisement: '일반',
  assigned: '지정',
  notAssigned: '미지정',
  awarded: '지급',
  notAwarded: '미지급',
  agreed: '동의',
  notAgreed: '미동의',
  approval: '승인',
  notApproval: '미승인',
  locked: '잠김',
  notLocked: '미잠김',
  completed: '완료',
  notCompleted: '미완료',
  success: '성공',
  failed: '실패',
  commonCategory: '일반 공지',
  communityCategory: '커뮤니티 공지',
  pushScheduled: '발송 예정',
  pushInProgress: '발송 중',
  pushCompleted: '발송 완료',
  pushInstant: '즉시 발송',
  pushReservation: '예약 발송',
} as const;

export const ENTRY_TYPE_OPTIONS = {
  DAILY: '매일 참여',
  NORMAL: '이벤트',
  FIRST_SERVED: '선착순',
  FREE: '무료',
} as const;

export const CONNECT_CONTENT_OPTIONS = {
  entry: '응모하기',
  donation: '기부하기',
  notice: '공지사항',
  magazine: '매거진',
} as const;

export const CUSTOMER_STATUS_OPTIONS = {
  normal: '일반 회원',
  suspended: '정지 회원',
  withdrawal: '탈퇴 회원',
} as const;

export const ACCOUNT_PROVIDER_OPTIONS = {
  kakao: '카카오',
  naver: '네이버',
  google: '구글',
  apple: '애플',
} as const;
